import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { AdditionalService } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/additional-services.model';
import * as fromAdditionalServicesAction from '@ordersnproducts/modules/order-builder/modules/location-specification/actions/additional-services.action';
import {
  LocationSpecificationActions,
  LocationSpecificationActionTypes,
} from '../actions/location-specifications.actions';

export interface State extends EntityState<AdditionalService> {
  selectedAdditionalServiceId: number | null;
}

export const adapter: EntityAdapter<AdditionalService> = createEntityAdapter<AdditionalService>({
  selectId: ($additionalService: AdditionalService) => $additionalService.commercialCode,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedAdditionalServiceId: null,
});

export function reducer(
  state = initialState,
  action: fromAdditionalServicesAction.Actions | LocationSpecificationActions,
): State {
  switch (action.type) {
    case fromAdditionalServicesAction.ActionTypes.ADD_ADDITIONAL_SERVICE: {
      return adapter.addMany(action.payload.additionalServices, { ...state });
    }
    case fromAdditionalServicesAction.ActionTypes.CLEAR_ADDITIONAL_SERVICE: {
      return adapter.removeAll(state);
    }
    case LocationSpecificationActionTypes.SET_LOCATION_SPECIFICATION_FROM_MODIFY: {
      const additionalServices = action.payload.additionalServices;
      return {
        ...additionalServices,
      };
    }
    case fromAdditionalServicesAction.ActionTypes.NO_ACTION:
    default: {
      return state;
    }
  }
}

export const getEntities = (state: State) => state.entities;

export const getAdditionalServices = (state: State) => {
  const AdditionalServices: AdditionalService[] = Object.keys(state.entities).map(i => state.entities[i]);
  return AdditionalServices;
};
